export const services = [
  {
    id: 7,
    title: "Prepaid Card",
    image: "/images/credit-card-icon.png",
  },
  {
    id: 1,
    title: "Credit Cards",
    image: "/images/credit-card-icon.png",
  },
  {
    id: 2,
    title: "Bank Accounts",
    image: "/images/bank-icon.png",
  },
  {
    id: 3,
    title: "Demat Accounts",
    image: "/images/demat-account-icon.png",
  },
  {
    id: 4,
    title: "Credit Line",
    image: "/images/credit-line-icon.png",
  },
  {
    id: 5,
    title: "Personal Loan",
    image: "/images/personal-loan-icon.png",
  },
  // {
  //   id: 6,
  //   title: "Investment",
  //   image: "/images/investment-icon.png",
  // },
  // {
  //   id: 7,
  //   title: "Mega Savings",
  //   image: "/images/discount-icon.png",
  // },
];
